import { KoobContainer } from '@koob/ui';
import { useParams, useSearchParams } from 'react-router-dom';
import { useAsync } from 'react-async';
import { getTrip } from '../../../api/trip';
import ComposeChatTrip from '../../TripDesigner/Chat/ComposeChatTrip';
import { Formik } from 'formik';
import KoobLayout from '../../../components/Koob/KoobLayout';
import KoobBackButton from '../../../components/Koob/KoobBackButton';
import KoobTitle from '../../../components/Koob/KoobTitle';
import React from 'react';

export default function TripChat() {
  const { tripId } = useParams();
  const [searchParams] = useSearchParams();

  const { data: tripData, reload } = useAsync({
    promiseFn: getTrip,
    tripId,
  });
  const trip = tripData?.data;

  return (
    <KoobLayout>
      <KoobContainer>
        <div className="mt-5 flex items-center space-x-5 px-9">
          <KoobBackButton />

          <KoobTitle>{trip?.name}</KoobTitle>
        </div>

        <Formik initialValues={trip ?? {}} onSubmit={() => {}}>
          <ComposeChatTrip
            tripId={tripId}
            reloadTrip={reload}
            trip={trip}
            initialQuestion={searchParams.get('question') ?? undefined}
          />
        </Formik>
      </KoobContainer>
    </KoobLayout>
  );
}
